/**
 * Screenshot der aktuell sichtbaren Seite – für das Feedback-Formular.
 *
 * html2canvas wird bewusst erst beim ersten Aufruf nachgeladen (dynamischer
 * Import), damit die ~200 kB nicht in jedem Seitenaufruf mitfliegen.
 *
 * Elemente mit `data-screenshot-hide` (Feedback-Button, Toasts) landen nicht
 * mit auf dem Bild – sonst fotografiert sich das Widget selbst.
 */
export async function captureViewport(): Promise<string> {
  const { default: html2canvas } = await import('html2canvas');

  const background =
    getComputedStyle(document.body).backgroundColor || 'rgb(11, 10, 9)';

  const canvas = await html2canvas(document.body, {
    useCORS: true,
    // allowTaint würde fremdgehostete Bilder (Karten-Kacheln, Avatare) ohne
    // CORS-Freigabe mitzeichnen – das Canvas wäre "getaintet" und toDataURL()
    // würde zwingend werfen. Mit false fehlen einzelne Bilder, der Screenshot
    // entsteht aber überhaupt.
    allowTaint: false,
    logging: false,
    backgroundColor: background,
    // Breite Displays runterskalieren: 1400 px reichen zum Draufschauen.
    scale: Math.min(1, 1400 / Math.max(1, window.innerWidth)),
    x: window.scrollX,
    y: window.scrollY,
    width: window.innerWidth,
    height: window.innerHeight,
    windowWidth: document.documentElement.scrollWidth,
    windowHeight: document.documentElement.scrollHeight,
    ignoreElements: (el) => el instanceof HTMLElement && el.dataset.screenshotHide !== undefined,
  });

  return canvas.toDataURL('image/jpeg', 0.7);
}
